export default __webpack_public_path__ + "static/media/editIconDark.338405f1.svg";